import script from "./switch_i18n.vue?vue&type=script&setup=true&lang=js"
export * from "./switch_i18n.vue?vue&type=script&setup=true&lang=js"

import "./switch_i18n.vue?vue&type=style&index=0&id=ff47c3fc&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff47c3fc"]])

export default __exports__